/**
 * `temporalId` musi być UUID stabilnym w obrębie draftu — serwer echem odsyła
 * go w wycenie, a przy `book` wykrywa duplikaty
 * (error.booking.duplicate_participant_id). Identyfikator jest per pozycja
 * formularza i żyje do przeładowania strony; nie niesie tożsamości między
 * żądaniami, bo każda para żądanie–odpowiedź koreluje się samodzielnie.
 */
const temporalIds: string[] = [];

export const getTemporalIdForIndex = (index: number): string => {
  while (temporalIds.length <= index) {
    temporalIds.push(crypto.randomUUID());
  }
  return temporalIds[index];
};
